import React from 'react';
import {
  ExperienceRoot,
  useFetchById,
  detachExperienceStyles
} from '@contentful/experiences-sdk-react';
import { StudioExperienceBlockFragment } from '@src/graphql/gql-types';
import Head from 'next/head';
import {
  CF_STUDIO_PREVIEW_CLIENT,
  CF_STUDIO_DELIVERY_CLIENT
} from '@src/services/contentful';
import {
  CONTENTFUL_STUDIO_EXPERIENCE_API_IDENTIFIER,
  CONTENTFUL_LOCALE
} from '@src/constants/contentful';
import styles from './StudioExperienceBlock.module.scss';

type StudioExperienceBlockProps = StudioExperienceBlockFragment & {
  isPreview: boolean;
};

const StudioExperienceBlock: React.FC<StudioExperienceBlockProps> = ({
  sys,
  isPreview = false
}) => {
  const { experience, isLoading, error } = useFetchById({
    client: isPreview ? CF_STUDIO_PREVIEW_CLIENT : CF_STUDIO_DELIVERY_CLIENT,
    experienceTypeId: CONTENTFUL_STUDIO_EXPERIENCE_API_IDENTIFIER,
    localeCode: CONTENTFUL_LOCALE,
    id: sys.id
  });

  if (error) {
    console.error('error: ', error);
  }

  if (!experience || isLoading || error) {
    return null;
  }

  if (!isPreview && !experience?.entityStore) {
    return null;
  }

  const stylesheet = experience ? detachExperienceStyles(experience) : null;

  return (
    <>
      <Head key={sys?.id}>
        <style data-ssg>{stylesheet}</style>
      </Head>
      <div className={styles.experience}>
        <ExperienceRoot experience={experience} locale={CONTENTFUL_LOCALE} />
      </div>
    </>
  );
};

export default StudioExperienceBlock;
